/**
 * @generated SignedSource<<b1f9f7d5a1156b4a8b00d84afd36057d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetCalendarOverviewEventItem_event$data = {
  readonly storeCalendar: {
    readonly color: string;
  };
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"CalendarOverviewEventItemDateTime_event">;
  readonly " $fragmentType": "WidgetCalendarOverviewEventItem_event";
};
export type WidgetCalendarOverviewEventItem_event$key = {
  readonly " $data"?: WidgetCalendarOverviewEventItem_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetCalendarOverviewEventItem_event">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetCalendarOverviewEventItem_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreCalendar",
      "kind": "LinkedField",
      "name": "storeCalendar",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CalendarOverviewEventItemDateTime_event"
    }
  ],
  "type": "CalendarEvent",
  "abstractKey": null
};

(node as any).hash = "0f843e0755fb08c63566a27f7283703d";

export default node;
